export default __webpack_public_path__ + "static/media/contentbg.e614c8e4.png";